import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Moment } from 'moment';
import { ModulService } from '../modul.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ClanoviService, PoslovniKorisnik, TrenutnoPrisutni, ZahtjevClanFitnet } from '../clanovi.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import * as validatori from '../validatori';

export interface Clanstvo {
  vClansID: number,
  vrstaIDcl: number,
  ClanIDcl: number,
  KlijentIDcl: number,
  pjedIDcl: number,
  PocetakDatum: Moment,
  KrajDatum: Moment,
  intAkt: number,
  korisnikID: number,
  Ime: string,
  Prezime: string,
  Adresa: string,
  Mjesto: string,
  NazivPos: string,
  AdresaPos: string,
  MjestoPos: string,
  opis_vrsta_cl: string
}

@Component({
  selector: 'app-clanstva',
  templateUrl: './clanstva.component.html',
  styleUrls: ['./clanstva.component.scss']
})
export class ClanstvaComponent implements OnInit {

  constructor(
    public mod: ModulService,
    private http: HttpClient,
    private router: Router,
    public srvClanovi: ClanoviService
  ) { 

    
  }

  @Output() dialgTrenOper: EventEmitter<any> = new EventEmitter();

  objClanstva: Clanstvo[];

  //session;

  ngOnInit() {
    setTimeout(()=>{
      this.ucitajClanstva(()=>{});
    },500);
    
  }

  //Učitaj članstva
  ucitajClanstva(callback) {

    if (localStorage.getItem('session')) {
      this.mod.session = JSON.parse(localStorage.getItem('session'));
    }

    let urlTmp: string = this.mod.webUrl + '/php/clanovi.php?token=' + this.mod.objKor.token + '&funk=korisnikClanstva';

    let obj = {
      korisnikID: this.mod.objKor.korisnikID
    }

    let obj2: string = JSON.stringify(obj);

    this.http.post(urlTmp, obj2).subscribe((rez: Clanstvo[]) => {
      this.objClanstva = rez;
      callback(rez);
    });

  }

  //Emitter Modal poslovne jedinice za prijavu trenera / operatera by KlijentID
  posJedTrenOper(val: Clanstvo) {
    this.mod.objClanstvo = val;
    this.dialgTrenOper.emit(val);
  }

  //Odjava Trener / Operater
  odjavaTrenOperStart() {

    document.getElementById('btnOdjavaTrenOper').click();

    this.srvClanovi.napraviFrmOdjava((rez) => {

    });

    /* this.mod.objPosJedSelected = null;
    localStorage.removeItem('objPosJedSelected');
    this.router.navigate(['cpanel1']); */
  }

  //Modal Novi zahtjev za povezivanje
  noviZahtjevStart() {

    this.srvClanovi.lstPoslovniKorisnici((rez: PoslovniKorisnik[]) => {

      if (rez) {

        this.srvClanovi.objPoslovniKor = rez;
        this.srvClanovi.fltPoslovniKor = null;

        let obj0: ZahtjevClanFitnet = {
          vfcID: 0,
          klijentIDvfc: 0,
          naziv: null,
          korIDvfc: this.mod.objKor.korisnikID, 
          clanIDvfc: 0, 
          statusVfc: 0, 
          DatumVfc: null
        }

        this.srvClanovi.napraviFrmZahtjevClFit(obj0, () => {
          document.getElementById('btnMdlZahtjevClFit').click();
        });

      } else {
        this.srvClanovi.objPoslovniKor = null;
        this.srvClanovi.fltPoslovniKor = null;
        this.mod.msgBox(2, "Greška prilikom učitavanja fitness centara!", 3000);
      }

    });

  }

}
